import { cn } from '@virginexperiencedays/tailwind';

import { ReviewSummary } from '../Reviews/Reviews';

import type { Reviews } from '../VariationPage/extractors';
import type { HTMLAttributes } from 'react';

type MetaWidgetProps = HTMLAttributes<HTMLDivElement> &
  Pick<Reviews, 'averageRating' | 'averageRatingDisplay' | 'count'> & {
    onReviewCountClick: () => void;
  };

export const MetaWidget = ({
  averageRating,
  averageRatingDisplay,
  count,
  onReviewCountClick,
  className,
  ...rest
}: MetaWidgetProps) => {
  if (!averageRating || !count) return null;

  return (
    <div className={cn('flex gap-2', className)} {...rest}>
      <ReviewSummary averageRating={averageRating} averageRatingDisplay={averageRatingDisplay} />

      {count && (
        <button
          onClick={onReviewCountClick}
          className="border-none bg-transparent text-sm font-[500] leading-normal text-brand underline underline-offset-2"
        >
          {count} Review{count > 1 && 's'}
        </button>
      )}
    </div>
  );
};
